import { fetcher } from '../base';

const url = 'cart/free-tees';

export const useFreeTees = () => {
  const getFreeTees = () => {
    return fetcher(url);
  };

  return {
    getFreeTees,
  };
};
